import React from 'react';
import SelectCtrl from 'react-select';
import { useDispatch } from 'react-redux';
import { setSelectedValue } from '../../../../../store/reducers/campaign';
import { placeholderStyle } from '../../../../AddSegment/Condition/Condition.constants';
import styles from './Select.module.scss';

const Select = ({ conditionId, label, value, data, placeholder }) => {
  const dispatch = useDispatch();

  const handleChange = (newValue) => {
    if (!value || newValue.value !== value.value) {
      dispatch(setSelectedValue({ conditionId, label, value: newValue }));
    }
  };

  return (
    <div className={styles.wrapper}>
      <SelectCtrl
        styles={placeholderStyle}
        placeholder={placeholder}
        maxMenuHeight={194}
        className="w-100"
        value={value}
        options={data}
        onChange={handleChange}
        isShowValue
      />
    </div>
  );
};

export default Select;
